import { CUSTOM_ELEMENTS_SCHEMA, Component, ComponentRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { StatusbarComponent } from './component/statusbar/statusbar.component';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './component/header/header.component';
import { AlertComponent } from './component/alert/alert.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [HeaderComponent, RouterOutlet, StatusbarComponent, AlertComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent{
  title = 'XRMFusion';



}
